import { Directive, OnInit, ElementRef, Renderer2, NgModule, HostListener, SimpleChanges, OnChanges, Input } from '@angular/core';


@Directive({
    selector: '[notRequired]'
})
export class AuthNotRequiredDirective implements OnInit {
    @Input() valueChanges: any;

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit() {
        const parent = this.renderer.parentNode(this.el.nativeElement);

        if (parent.getElementsByTagName('SPAN').length) {
            if (!parent.getElementsByClassName('empty').length) {
                if (this.valueChanges === null || this.valueChanges === undefined || this.valueChanges === "")
                    parent.getElementsByClassName('floating-label')[0]?.classList.add("empty");                
            }
            else {
                if (this.valueChanges !== null && this.valueChanges !== undefined && this.valueChanges !== "")
                    parent.getElementsByClassName('floating-label')[0].classList.remove("empty");
            }
        }


    }
    @HostListener("focus", ["$event.target"])
  onFocus(target) {
    
       
            const parent = this.renderer.parentNode(this.el.nativeElement);
            if (parent.getElementsByTagName('SPAN').length) {
                if (parent.getElementsByClassName('empty').length) {                   
                        parent.getElementsByClassName('floating-label')[0].classList.remove("empty");
                }                
            }
            
        }
        @HostListener("blur", ["$event.target"])
  onBlur(target) {
    
    const parent = this.renderer.parentNode(this.el.nativeElement);
    if (parent.getElementsByTagName('SPAN').length) {
        if (!parent.getElementsByClassName('empty').length) {
            if (this.el.nativeElement.value === null || this.el.nativeElement.value === undefined || this.el.nativeElement.value === "")
                parent.getElementsByClassName('floating-label')[0].classList.add("empty");
        }
        else {
            if (this.el.nativeElement.value !== null && this.el.nativeElement.value !== undefined && this.el.nativeElement.value !== "")
                parent.getElementsByClassName('floating-label')[0].classList.remove("empty");
        }
    }
  }
  ngOnChanges(changes: SimpleChanges){
    if(changes.valueChanges){
        let value:any = changes["valueChanges"].currentValue;
        const parent = this.renderer.parentNode(this.el.nativeElement);
        if (parent.getElementsByTagName('SPAN').length) {
            if (!parent.getElementsByClassName('empty').length) {
                if (value === null || value === undefined || value === "")
                {
                    parent.getElementsByClassName('floating-label')[0].classList.add("empty");
                }
            }
            else {
                if (value !== null && value !== undefined && value !== "")
                    parent.getElementsByClassName('floating-label')[0].classList.remove("empty");
            }
        }
    }
  }
//     @HostListener("input", ["$event.target.value"])
//   onInput(value) {
    
       
//             const parent = this.renderer.parentNode(this.el.nativeElement);
//             if (parent.getElementsByTagName('SPAN').length) {
//                 if (!parent.getElementsByClassName('empty').length) {
//                     if (this.el.nativeElement.value === null || this.el.nativeElement.value === undefined || this.el.nativeElement.value === "")
//                         parent.getElementsByClassName('floating-label')[0].classList.add("empty");
//                 }
//                 else {
//                     if (this.el.nativeElement.value !== null && this.el.nativeElement.value !== undefined && this.el.nativeElement.value !== "")
//                         parent.getElementsByClassName('floating-label')[0].classList.remove("empty");
//                 }
//             }
//             console.log("change event triggered!");
//         }
      
    
}
@NgModule({
    declarations: [AuthNotRequiredDirective],
    exports: [AuthNotRequiredDirective]
})

export class AuthNotRequiredDirectiveModule { }